import React, {useState} from 'react';
import './RulesAccept.css';
import RegisterAccept from "../../Pages/Registration/RegisterAccept/RegisterAccept";
import axios from "axios";
import {useNavigate} from "react-router-dom";
import AcceptPersonalData from "../../Pages/Registration/AcceptPersonalData/AcceptPersonalData";

const RulesAccept = () => {

    const navigate = useNavigate();

    const [isRegisterModalOpen, setIsRegisterModalOpen] = useState(false);
    const [isPersDataModalOpen, setIsPersDataModalOpen] = useState(false);
    const [isCheckbox, setIsCheckbox] = useState(false);
    const [isCheckbox_2, setIsCheckbox_2] = useState(false);

    const changeCheckbox = () => {
        setIsCheckbox(prevState => !prevState);
    }

    const changeCheckbox_2 = () => {
        setIsCheckbox_2(prevState => !prevState);
    }

    const openAcceptModal = () => {
        // e.preventDefault();
        setIsRegisterModalOpen(true);
    }

    const openPersDataModal = () => {
        setIsPersDataModalOpen(true);
    }

    const userAcceptRules = () => {
        axios.get(`/api/user_read/`, {headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': 'X-CSRFToken'
            }, withCredentials: true})
            .then(res => {
                console.log(res);
                window.location.reload();
            })
            .catch(e => {
                console.log(e);
                if (e.status === 401) {
                    navigate('/login');
                }
        })
    }

    return (
        <div className={'rules-accept-main-block'}>
            <div className={'rules-accept-checkbox-block'}>
                <input type={'checkbox'} className={'rules-accept-checkbox'}
                       onClick={changeCheckbox}/>
                <p className={'rules-accept-text'}>Я согласен с <a className={'rules-accept-link-open-reg-modal'}
                                                                   onClick={openAcceptModal}>Правилами
                    поведения на корте</a></p>
            </div>

            <div className={'rules-accept-checkbox-block'}>
                <input type={'checkbox'} className={'rules-accept-checkbox'} id={'cort-rules-checkbox-id'}
                       onClick={changeCheckbox_2}/>
                <p className={'rules-accept-text'}>Я согласен на <a className={'rules-accept-link-open-reg-modal'}
                                                                  onClick={openPersDataModal}>обработку
                    персональных данных</a></p>
            </div>

            <div className={'register-submit-block'}>
                <input type={'button'} value={'Принять'}
                       className={`rules-accept-register-submit-button ${(isCheckbox && isCheckbox_2) ? '' : 'register-submit-button-not-active'}`}
                       onClick={() => userAcceptRules()}/>
            </div>

            <RegisterAccept
                isOpen={isRegisterModalOpen}
                onRequestClose={setIsRegisterModalOpen}
            />

            <AcceptPersonalData
                isOpen={isPersDataModalOpen}
                onRequestClose={setIsPersDataModalOpen}
            />

        </div>
    );
};

export default RulesAccept;